import { AsyncStoreItem } from '@lib/store';
import { GetDocumentListResponse } from 'src/sdk-servicing';

/**
 * GetDocumentList model
 */
export interface GetDocumentListModel {
  model: GetDocumentListResponse | null;
}

/**
 * GetDocumentListResponse model details
 */
export interface GetDocumentListStateDetails extends AsyncStoreItem {}

/**
 * GetDocumentList store state
 */
export interface GetDocumentListState extends GetDocumentListStateDetails, GetDocumentListModel {}

/**
 * Name of the GetDocumentList Store
 */
export const GET_DOCUMENT_LIST_STORE_NAME = 'getDocumentList';

/**
 * GetDocumentList Store Interface
 */
export interface GetDocumentListStore {
  /** GetDocumentList state */
  [GET_DOCUMENT_LIST_STORE_NAME]: GetDocumentListState;
}
